import {Component, inject, OnInit} from '@angular/core';
import {BaseOverlayComponent} from "../../../../shared/components/overlay/base-overlay/base-overlay.component";
import {DropdownComponent} from "../../../../shared/inputs/dropdown/dropdown.component";
import {BaseComponent} from "../../../../shared/base/base-component";
import {ApiService} from "../../../../core/api/api.service";

import {State} from "../../../../shared/base/base-state";
import {ButtonComponent} from "../../../../shared/components/button/button.component";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {DIALOG_DATA, DialogRef} from "@angular/cdk/dialog";
import {
  GetCompanyListResponse,
  GetTenantListResponse,
  LinkCompanyToTenantRequest,
  LinkCompanyToTenantResponse
} from "../../../../core/api/model";

@Component({
  selector: 'app-link-company-to-tenant',
  imports: [
    BaseOverlayComponent,
    DropdownComponent,
    ButtonComponent,
    ReactiveFormsModule
  ],
  templateUrl: './link-company-to-tenant.component.html',
  styleUrl: './link-company-to-tenant.component.scss'
})
export class LinkCompanyToTenantComponent extends BaseComponent implements OnInit {
  apiService = inject(ApiService);
  data = inject(DIALOG_DATA);
  dialogRef = inject(DialogRef);

  getCompanyListState = new State<GetCompanyListResponse>();
  getTenantListState = new State<GetTenantListResponse>();
  linkCompanyToTenantState = new State<LinkCompanyToTenantResponse>();

  formBuilder = inject(FormBuilder);
  linkCompanyToTenantForm!: FormGroup;


  ngOnInit() {
    this.initForm();
    this.getCompanyList();
    this.getTenantList();
  }

  initForm() {
    this.linkCompanyToTenantForm = this.formBuilder.group({
      companyId: ["", Validators.required],
      sourceTenantId: ["", Validators.required],
      targetTenantId: ["", Validators.required]
    })
  }

  getCompanyList() {
    this.executeRequest<GetCompanyListResponse>({
      state: this.getCompanyListState,
      request: this.apiService.getCompanyList(),
    });
  }

  getTenantList() {
    this.executeRequest<GetTenantListResponse>({
      state: this.getTenantListState,
      request: this.apiService.getTenantList()
    });
  }

  linkCompanyToTenant() {
    let value = this.linkCompanyToTenantForm.value;

    let request: LinkCompanyToTenantRequest = {
      companyId: value.companyId,
      sourceTenantId: this.data.id,
      targetTenantId: this.data.id,
    };

    this.executeRequest({
      state: this.linkCompanyToTenantState,
      request: this.apiService.linkCompanyToTenant(request),
      handleSuccess: true,
      handleError: true,
      onSuccess: response => {
        this.dialogRef.close(true);
      }
    });
  }


}

